export const translations = {
  en: {
    // Navigation
    nav: {
      dashboard: "Dashboard",
      cabinets: "Cabinets",
      operations: "Operations",
      users: "Users",
      vendors: "Vendors",
      lists: "Lists",
      settings: "Settings",
      logout: "Logout",
      profile: "Profile",
      shares: "Shares",
      investors: "Investors",
      spareParts: "Spare Parts",
    },
    // Auth
    auth: {
      login: "Login",
      register: "Register",
      loginTitle: "Welcome Back",
      loginSubtitle: "Enter your credentials to access your fleet",
      registerTitle: "Create Account",
      registerSubtitle: "Join the arcade management revolution",
      username: "Username",
      password: "Password",
      confirmPassword: "Confirm Password",
      email: "Email",
      nickname: "Nickname",
      forgotPassword: "Forgot password?",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      signIn: "Sign In",
      signUp: "Sign Up",
      forgotPasswordTitle: "Reset your password",
      forgotPasswordSubtitle: "Enter your username or email and we'll send you a reset link.",
      loginOrEmail: "Username or email",
      sendResetLink: "Send reset link",
      resetLinkSent: "If an account matches, a reset email has been sent.",
      backToLogin: "Back to login",
      resetPasswordTitle: "Choose a new password",
      resetPasswordSubtitle: "Enter a new password for your account.",
      newPassword: "New password",
      confirmNewPassword: "Confirm new password",
      resetPasswordBtn: "Update password",
      resettingPassword: "Updating...",
      passwordResetSuccess: "Password updated. You can now sign in.",
      resetLinkInvalid: "This reset link is invalid or has expired.",
      missingResetToken: "Missing reset token.",
      captchaLabel: "Anti-bot check",
      captchaPrompt: "How much is",
      captchaPlaceholder: "Answer",
      captchaError: "Wrong anti-bot answer, please try again.",
    },
    // Dashboard
    dashboard: {
      title: "Fleet Overview",
      totalCabinets: "Total Cabinets",
      inStock: "In Stock",
      outOfStock: "Out of Stock",
      totalInvestment: "Total Investment",
      totalRevenue: "Total Revenue",
      recentOperations: "Recent Operations",
      cabinetsByType: "Cabinets by Type",
      noData: "No data available",
      monthlyActivity: "Monthly Activity (for last 13 month)",
      byInvestor: "By investor",
      lblPurchases: "Purchases",
      lblSales: "Sales",
      lblRepairs: "Repairs",
      lblSystems: "Systems",
    },
    // Cabinets
    cabinets: {
      title: "Cabinet Fleet",
      addCabinet: "Add Cabinet",
      editCabinet: "Edit Cabinet",
      deleteCabinet: "Delete Cabinet",
      cabinetDetails: "Cabinet Details",
      friendlyName: "Friendly Name",
      uniqueId: "Unique ID",
      vendor: "Vendor",
      type: "Type",
      inStock: "In Stock",
      outOfStock: "Out of Stock",
      status: "Status",
      photos: "Photos",
      specifications: "Specifications",
      history: "Change History",
      operations: "Operations",
      screens: "Screens",
      boards: "Boards",
      coinMechanism: "Coin Mechanism",
      dimensions: "Dimensions",
      dimensionslabel:"H x W x D cm",
      height: "Height",
      width: "Width",
      depth: "Depth",
      weight: "Weight",
      audioSystem: "Audio System",
      screenOrientation: "Screen Orientation",
      screenOrientationVal3: "both",
      orientationlbl: "Orientation (yoko/tate/both)",
      wiring: "Wiring",
      playingPosition: "Playing Position",
      numberOfPlayers: "Number of Players",
      controls: "Controls",
      buttons: "Buttons",
      topper: "Topper",
      mainPhoto: "Main Photo",
      addPhoto: "Add Photo",
      deletePhoto: "Delete Photo",
      editPhoto: "Edit photo",
      cropHint: "Drag on the image to select the area to keep, then resize the handles.",
      ratio: "Ratio",
      zoom: "Zoom",
      rotation: "Rotation",
      maxPhotos: "Maximum 10 photos allowed",
      search: "Search cabinets...",
      filterByVendor: "Filter by vendor",
      filterByType: "Filter by type",
      filterByStock: "Filter by stock",
      filterByYear: "Filter by year",
      allYears: "All years",
      sortBy: "Sort by",
      oldestFirst: "Oldest first",
      newestFirst: "Newest first",
      all: "All",
      confirmDelete: "Are you sure you want to delete this cabinet?",
      deleteWarning: "This action cannot be undone. All associated operations will also be deleted.",
    },
    // Operations
    operations: {
      title: "Operations",
      addOperation: "Add Operation",
      editOperation: "Edit Operation",
      deleteOperation: "Delete Operation",
      type: "Type",
      purchase: "Purchase",
      purchase_system: "Purchase system",
      sale: "Sale",
      repair: "Repair",
      date: "Date",
      description: "Description",
      price: "Price",
      transportCost: "Transport Cost",
      priceBreakdown: "Price Breakdown",
      affectedComponents: "Affected Components",
      addInvestor: "Add Investor",
      investor: "Investor",
      amount: "Amount",
      totalMustEqual: "Total must equal purchase price (with shipping)",
      search: "Search operations...",
      filterByType: "Filter by type",
      cabinet: "Cabinet",
      purchaseSystem: "Purchase system",
    },
    // Users
    users: {
      title: "User Management",
      addUser: "Add User",
      editUser: "Edit User",
      deleteUser: "Delete User",
      login: "Login",
      nickname: "Nickname",
      email: "Email",
      role: "Role",
      administrator: "Administrator",
      editor: "Editor",
      viewer: "Viewer",
      avatar: "Avatar",
      createdAt: "Created At",
      confirmDelete: "Are you sure you want to delete this user?",
      newPassword: "New Password",
      newPasswordHint: "Leave blank to keep the current password",
    },
    // Vendors
    vendors: {
      title: "Vendor Management",
      addVendor: "Add Vendor",
      deleteVendor: "Delete Vendor",
      name: "Vendor Name",
      createdBy: "Created By",
      confirmDelete: "Are you sure you want to delete this vendor?",
      inUseWarning: "Cannot delete vendor that is in use by cabinets",
    },
    // Lists
    lists: {
      title: "Enrichable Lists",
      addItem: "Add Item",
      deleteItem: "Delete Item",
      listType: "List Type",
      value: "Value",
      screen: "Screens",
      board: "Boards",
      control: "Controls",
      button: "Buttons",
      topper: "Toppers",
      wiring: "Wiring Types",
      component: "Components",
      cabinet_type: "Type of cabinet",
    },
    // Investors
    investors: {
      title: "Investors",
      subtitle: "People who invested in the fleet",
      totalInvested: "Total invested",
      shareOfTotal: "Share of total",
      operations: "Operations",
      cabinets: "Cabinets",
      byType: "By operation type",
      perCabinet: "Investment per cabinet",
      operationsList: "Investment operations",
      amount: "Amount",
      noData: "No investment recorded yet",
      backToList: "Back to investors",
      viewCabinet: "View cabinet",
      notFound: "Investor not found",
      rank: "Rank",
      spareParticipation: "Spare parts participation",
      spareParticipationNote: "Indicative — not included in the total (a part's cost is counted in the cabinet operations when used)",
      spareParticipationShort: "Spare parts",
    },
    // Spare Parts
    spareParts: {
      title: "Spare Parts",
      subtitle: "Parts inventory, independent from cabinets until used",
      addPart: "Add Part",
      editPart: "Edit Part",
      deletePart: "Delete Part",
      name: "Part name",
      namePlaceholder: "e.g. Capacitor HV CRT 450V",
      reference: "Reference",
      category: "Category",
      supplier: "Supplier",
      supplierPlaceholder: "e.g. AliExpress, Farnell…",
      price: "Price",
      transportCost: "Shipping",
      quantityPurchased: "Quantity",
      quantityAvailable: "Available",
      usedOn: "Used on",
      searchCabinet: "Search a cabinet...",
      unitCost: "Unit cost",
      totalCost: "Total cost",
      purchaseDate: "Purchase date",
      notes: "Notes",
      investors: "Investors (purchase)",
      addInvestor: "Add investor",
      investor: "Investor",
      amount: "Amount",
      totalMustEqual: "Investor total must equal price + shipping",
      inStock: "In stock",
      outOfStock: "Out of stock",
      lot: "Lot",
      unit: "Unit",
      use: "Use on a cabinet",
      useTitle: "Use part on a cabinet",
      cabinet: "Cabinet",
      quantityUsed: "Quantity to use",
      description: "Description",
      available: "available",
      costPreview: "Cost added to the cabinet",
      investorSplit: "Investor split (by purchase ratio)",
      defaultUseDescription: "Use of {name} x {qty}",
      confirmDelete: "Delete this spare part? Only parts never used on a cabinet can be deleted.",
      noData: "No spare parts yet",
      search: "Search parts...",
      used: "used",
    },
    // Settings
    settings: {
      title: "Settings",
      profile: "Profile",
      changePassword: "Change Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmNewPassword: "Confirm New Password",
      language: "Language",
      theme: "Theme",
      darkMode: "Dark Mode",
      lightMode: "Light Mode",
      english: "English",
      french: "French",
      saveChanges: "Save Changes",
      passwordChanged: "Password changed successfully",
      profileUpdated: "Profile updated successfully",
    },
    // Common
    common: {
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      view: "View",
      close: "Close",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      confirm: "Confirm",
      yes: "Yes",
      no: "No",
      actions: "Actions",
      noResults: "No results found",
      required: "Required",
      optional: "Optional",
      selectOption: "Select an option",
      addNew: "Add new...",
      cm: "cm",
      kg: "kg",
      currency: "€",
    },
    // Errors
    errors: {
      invalidCredentials: "Invalid credentials",
      userExists: "User with this login or email already exists",
      unauthorized: "Unauthorized access",
      notFound: "Not found",
      serverError: "Server error. Please try again.",
      requiredField: "This field is required",
      invalidEmail: "Invalid email address",
      passwordMismatch: "Passwords do not match",
      minLength: "Minimum {min} characters required",
    },
    // Coin mechanisms
    coinMechanisms: {
      yen: "Yen",
      euro: "Euro",
      other: "Other",
    },
    // Audio systems
    audioSystems: {
      mono: "Mono",
      stereo: "Stereo",
    },
    // Screen orientations
    screenOrientations: {
      yoko: "Yoko (Horizontal)",
      tate: "Tate (Vertical)",
      both: "Both",
    },
    // Playing positions
    playingPositions: {
      standing: "Standing",
      seated: "Seated",
    },
    // Cabinet types
    cabinetTypes: {
      "Generic EURO": "Generic EURO",
      "Generic US": "Generic US",
      "Generic Other": "Generic Other",
      "Racing": "Racing",
      "Racing Double": "Racing Double",
      "Musical": "Musical",
      "Pinball": "Pinball",
    },
  },
  fr: {
    // Navigation
    nav: {
      dashboard: "Tableau de bord",
      cabinets: "Bornes",
      operations: "Opérations",
      users: "Utilisateurs",
      vendors: "Fabricants",
      lists: "Listes",
      settings: "Paramètres",
      logout: "Déconnexion",
      profile: "Profil",
      shares: "Partages",
      investors: "Investisseurs",
      spareParts: "Pièces détachées",
    },
    // Auth
    auth: {
      login: "Connexion",
      register: "Inscription",
      loginTitle: "Bon retour",
      loginSubtitle: "Entrez vos identifiants pour accéder à votre flotte",
      registerTitle: "Créer un compte",
      registerSubtitle: "Rejoignez la révolution de la gestion d'arcade",
      username: "Nom d'utilisateur",
      password: "Mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      email: "Email",
      nickname: "Pseudonyme",
      forgotPassword: "Mot de passe oublié ?",
      noAccount: "Pas encore de compte ?",
      hasAccount: "Déjà un compte ?",
      signIn: "Se connecter",
      signUp: "S'inscrire",
      forgotPasswordTitle: "Réinitialiser votre mot de passe",
      forgotPasswordSubtitle: "Entrez votre identifiant ou votre email, nous vous enverrons un lien de réinitialisation.",
      loginOrEmail: "Identifiant ou email",
      sendResetLink: "Envoyer le lien",
      resetLinkSent: "Si un compte correspond, un email de réinitialisation a été envoyé.",
      backToLogin: "Retour à la connexion",
      resetPasswordTitle: "Choisir un nouveau mot de passe",
      resetPasswordSubtitle: "Entrez un nouveau mot de passe pour votre compte.",
      newPassword: "Nouveau mot de passe",
      confirmNewPassword: "Confirmer le nouveau mot de passe",
      resetPasswordBtn: "Mettre à jour le mot de passe",
      resettingPassword: "Mise à jour...",
      passwordResetSuccess: "Mot de passe mis à jour. Vous pouvez vous connecter.",
      resetLinkInvalid: "Ce lien de réinitialisation est invalide ou a expiré.",
      missingResetToken: "Jeton de réinitialisation manquant.",
      captchaLabel: "Vérification anti-robot",
      captchaPrompt: "Combien font",
      captchaPlaceholder: "Réponse",
      captchaError: "Mauvaise réponse anti-robot, réessayez.",
    },
    // Dashboard
    dashboard: {
      title: "Vue d'ensemble de la flotte",
      totalCabinets: "Total des bornes",
      inStock: "En stock",
      outOfStock: "Hors stock",
      totalInvestment: "Investissement total",
      totalRevenue: "Revenu total",
      recentOperations: "Opérations récentes",
      cabinetsByType: "Bornes par type",
      noData: "Aucune donnée disponible",
      monthlyActivity: "Activité mensuelle (13 dernier mois)",
      byInvestor: "Par investisseur",
      lblPurchases: "Achats",
      lblSales: "Ventes",
      lblRepairs: "Réparations",
      lblSystems: "Systèmes",
    },
    // Cabinets
    cabinets: {
      title: "Flotte de bornes",
      addCabinet: "Ajouter une borne",
      editCabinet: "Modifier la borne",
      deleteCabinet: "Supprimer la borne",
      cabinetDetails: "Détails de la borne",
      friendlyName: "Nom",
      uniqueId: "ID unique",
      vendor: "Fabricant",
      type: "Type",
      inStock: "En stock",
      outOfStock: "Hors stock",
      status: "Statut",
      photos: "Photos",
      specifications: "Spécifications",
      history: "Historique des modifications",
      operations: "Opérations",
      screens: "Écrans",
      boards: "Cartes",
      coinMechanism: "Mécanisme de pièces",
      dimensions: "Dimensions",
      dimensionslabel:"Hauteur x Largeur x Profondeur cm",
      height: "Hauteur",
      width: "Largeur",
      depth: "Profondeur",
      weight: "Poids",
      audioSystem: "Système audio",
      screenOrientation: "Orientation de l'écran",
      screenOrientationVal3: "les deux",
      orientationlbl: "Orientation (yoko/tate/les deux)",
      wiring: "Câblage",
      playingPosition: "Position de jeu",
      numberOfPlayers: "Nombre de joueurs",
      controls: "Contrôles",
      buttons: "Boutons",
      topper: "Topper",
      mainPhoto: "Photo principale",
      addPhoto: "Ajouter une photo",
      deletePhoto: "Supprimer la photo",
      editPhoto: "Modifier la photo",
      cropHint: "Dessinez sur l'image la zone à conserver, puis ajustez les poignées.",
      ratio: "Ratio",
      zoom: "Zoom",
      rotation: "Rotation",
      maxPhotos: "Maximum 10 photos autorisées",
      search: "Rechercher des bornes...",
      filterByVendor: "Filtrer par fabricant",
      filterByType: "Filtrer par type",
      filterByStock: "Filtrer par stock",
      filterByYear: "Filtrer par année",
      allYears: "Toutes les années",
      sortBy: "Trier par",
      oldestFirst: "Plus ancienne d'abord",
      newestFirst: "Plus récente d'abord",
      all: "Tous",
      confirmDelete: "Êtes-vous sûr de vouloir supprimer cette borne ?",
      deleteWarning: "Cette action est irréversible. Toutes les opérations associées seront également supprimées.",
    },
    // Operations
    operations: {
      title: "Opérations",
      addOperation: "Ajouter une opération",
      editOperation: "Modifier l'opération",
      deleteOperation: "Supprimer l'opération",
      type: "Type",
      purchase: "Achat",
      sale: "Vente",
      repair: "Réparation",
      purchase_system: "Achat système",
      date: "Date",
      description: "Description",
      price: "Prix",
      transportCost: "Coût de transport",
      priceBreakdown: "Répartition du prix",
      affectedComponents: "Composants affectés",
      addInvestor: "Ajouter un investisseur",
      investor: "Investisseur",
      amount: "Montant",
      totalMustEqual: "Le total doit être égal au prix d'achat ( avecfrais de transport)",
      search: "Rechercher des opérations...",
      filterByType: "Filtrer par type",
      cabinet: "Borne",
      purchaseSystem: "Achat système",
    },
    // Users
    users: {
      title: "Gestion des utilisateurs",
      addUser: "Ajouter un utilisateur",
      editUser: "Modifier l'utilisateur",
      deleteUser: "Supprimer l'utilisateur",
      login: "Identifiant",
      nickname: "Pseudonyme",
      email: "Email",
      role: "Rôle",
      administrator: "Administrateur",
      editor: "Éditeur",
      viewer: "Lecteur",
      avatar: "Avatar",
      createdAt: "Créé le",
      confirmDelete: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
      newPassword: "Nouveau mot de passe",
      newPasswordHint: "Laisser vide pour conserver le mot de passe actuel",
    },
    // Vendors
    vendors: {
      title: "Gestion des fabricants",
      addVendor: "Ajouter un fabricant",
      deleteVendor: "Supprimer le fabricant",
      name: "Nom du fabricant",
      createdBy: "Créé par",
      confirmDelete: "Êtes-vous sûr de vouloir supprimer ce fabricant ?",
      inUseWarning: "Impossible de supprimer un fabricant utilisé par des bornes",
    },
    // Lists
    lists: {
      title: "Listes enrichissables",
      addItem: "Ajouter un élément",
      deleteItem: "Supprimer l'élément",
      listType: "Type de liste",
      value: "Valeur",
      screen: "Écrans",
      board: "Cartes",
      control: "Contrôles",
      button: "Boutons",
      topper: "Toppers",
      wiring: "Types de câblage",
      component: "Composants",
      cabinet_type: "Type de machine",
    },
    // Investors
    investors: {
      title: "Investisseurs",
      subtitle: "Personnes ayant investi dans la flotte",
      totalInvested: "Total investi",
      shareOfTotal: "Part du total",
      operations: "Opérations",
      cabinets: "Bornes",
      byType: "Par type d'opération",
      perCabinet: "Investissement par borne",
      operationsList: "Opérations d'investissement",
      amount: "Montant",
      noData: "Aucun investissement enregistré pour le moment",
      backToList: "Retour aux investisseurs",
      viewCabinet: "Voir la borne",
      notFound: "Investisseur introuvable",
      rank: "Rang",
      spareParticipation: "Participation aux pièces détachées",
      spareParticipationNote: "Indicatif — non inclus dans le total (le coût d'une pièce est compté dans les opérations de la borne lors de son utilisation)",
      spareParticipationShort: "Pièces détachées",
    },
    // Spare Parts
    spareParts: {
      title: "Pièces détachées",
      subtitle: "Inventaire des pièces, indépendant des bornes jusqu'à utilisation",
      addPart: "Ajouter une pièce",
      editPart: "Modifier la pièce",
      deletePart: "Supprimer la pièce",
      name: "Nom de la pièce",
      namePlaceholder: "ex. Condensateur HV CRT 450V",
      reference: "Référence",
      category: "Catégorie",
      supplier: "Fournisseur",
      supplierPlaceholder: "ex. AliExpress, Farnell…",
      price: "Prix",
      transportCost: "Frais de port",
      quantityPurchased: "Quantité",
      quantityAvailable: "Disponible",
      usedOn: "Utilisée sur",
      searchCabinet: "Rechercher une borne...",
      unitCost: "Coût unitaire",
      totalCost: "Coût total",
      purchaseDate: "Date d'achat",
      notes: "Notes",
      investors: "Investisseurs (achat)",
      addInvestor: "Ajouter un investisseur",
      investor: "Investisseur",
      amount: "Montant",
      totalMustEqual: "Le total investisseurs doit égaler prix + frais de port",
      inStock: "En stock",
      outOfStock: "Hors stock",
      lot: "Lot",
      unit: "Unité",
      use: "Utiliser sur une borne",
      useTitle: "Utiliser la pièce sur une borne",
      cabinet: "Borne",
      quantityUsed: "Quantité à utiliser",
      description: "Description",
      available: "disponible(s)",
      costPreview: "Coût ajouté à la borne",
      investorSplit: "Répartition investisseurs (au prorata d'achat)",
      defaultUseDescription: "Utilisation de {name} x {qty}",
      confirmDelete: "Supprimer cette pièce ? Seules les pièces jamais utilisées sur une borne peuvent être supprimées.",
      noData: "Aucune pièce détachée pour l'instant",
      search: "Rechercher une pièce...",
      used: "utilisée(s)",
    },
    // Settings
    settings: {
      title: "Paramètres",
      profile: "Profil",
      changePassword: "Changer le mot de passe",
      currentPassword: "Mot de passe actuel",
      newPassword: "Nouveau mot de passe",
      confirmNewPassword: "Confirmer le nouveau mot de passe",
      language: "Langue",
      theme: "Thème",
      darkMode: "Mode sombre",
      lightMode: "Mode clair",
      english: "Anglais",
      french: "Français",
      saveChanges: "Enregistrer les modifications",
      passwordChanged: "Mot de passe modifié avec succès",
      profileUpdated: "Profil mis à jour avec succès",
    },
    // Common
    common: {
      save: "Enregistrer",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      add: "Ajouter",
      view: "Voir",
      close: "Fermer",
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      confirm: "Confirmer",
      yes: "Oui",
      no: "Non",
      actions: "Actions",
      noResults: "Aucun résultat trouvé",
      required: "Requis",
      optional: "Optionnel",
      selectOption: "Sélectionner une option",
      addNew: "Ajouter nouveau...",
      cm: "cm",
      kg: "kg",
      currency: "€",
    },
    // Errors
    errors: {
      invalidCredentials: "Identifiants invalides",
      userExists: "Un utilisateur avec cet identifiant ou email existe déjà",
      unauthorized: "Accès non autorisé",
      notFound: "Non trouvé",
      serverError: "Erreur serveur. Veuillez réessayer.",
      requiredField: "Ce champ est requis",
      invalidEmail: "Adresse email invalide",
      passwordMismatch: "Les mots de passe ne correspondent pas",
      minLength: "Minimum {min} caractères requis",
    },
    // Coin mechanisms
    coinMechanisms: {
      yen: "Yen",
      euro: "Euro",
      other: "Autre",
    },
    // Audio systems
    audioSystems: {
      mono: "Mono",
      stereo: "Stéréo",
    },
    // Screen orientations
    screenOrientations: {
      yoko: "Yoko (Horizontal)",
      tate: "Tate (Vertical)",
      both: "Les deux",
    },
    // Playing positions
    playingPositions: {
      standing: "Debout",
      seated: "Assis",
    },
    // Cabinet types
    cabinetTypes: {
      "Generic EURO": "Générique EURO",
      "Generic US": "Générique US",
      "Generic Other": "Générique Autre",
      "Racing": "Course",
      "Racing Double": "Course Double",
      "Musical": "Musical",
      "Pinball": "Flipper",
    },
  },
};

export const detectBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  return browserLang.startsWith('fr') ? 'fr' : 'en';
};
